import { statusMatchesReference } from './isEveryPropertyDefined.tsx';
import type { ItemReference, Positionable } from './ListEdgeDetails.tsx';
import type { DiagramStatus, Point, StatefulDiagramStatus } from './toPortInfo.tsx';

interface Options {
	statuses: DiagramStatus[];
	selectedItem: ItemReference | undefined;
	targetedItem: ItemReference | undefined;
	hoveredItem: ItemReference | undefined;
	draggingItem: Positionable | undefined;
	movingItem: Positionable | undefined;
	defaultPositions: Record<string, Point>;
}

export const useStatefulStatuses = ({
	statuses,
	selectedItem,
	targetedItem,
	hoveredItem,
	draggingItem,
	movingItem,
	defaultPositions,
}: Options): StatefulDiagramStatus[] =>
	statuses.map((status) => {
		let position = status.position || defaultPositions[status.id];
		const isDragging = draggingItem?.type === 'status' && draggingItem?.id === status.id;
		const isMoving = movingItem?.type === 'status' && movingItem?.id === status.id;

		if (isDragging) {
			position = draggingItem.position;
		}

		if (isMoving) {
			position = movingItem.position;
		}

		return {
			...status,
			position,
			isSelected: statusMatchesReference(status, selectedItem),
			isTargeted: statusMatchesReference(status, targetedItem),
			isHovered: statusMatchesReference(status, hoveredItem),
			isDragging,
			isMoving,
		};
	});
